import React from 'react';
import { useTranslation } from 'react-i18next';
import securityBanner from '../../assets/images/security_banner.png';
import logoCommonImg from '../../assets/images/logo-common.svg';
import AuthSuccess from '../../templates/AuthSuccess';
import { Link, Paragraph, Headings } from '@sentara-health/optimahealth_web';

const IAMAuthSuccess = () => {
  //Initialize translation hook
  const { t } = useTranslation();
  const AuthBannerImg = securityBanner;
  const AuthLogoCommon = logoCommonImg;
  const AuthSuccessContent = (
    <>
      <Headings
        level={1}
        text={t('imAuthenticationSuccess.title')}
        variant="semiBold"
      />
      <Paragraph
        text={t('imAuthenticationSuccess.description')}
        variant="regular"
      />
      <Paragraph
        text={
          <>
            {t('imAuthenticationSuccess.welcomeEmail')}{' '}(
            {t('imAuthenticationSuccess.sentFrom')}
            <Link to="mailto:SOAR@sentara.com" className="darkblue-color ps-1">
              {t('imAuthenticationSuccess.emailId')}
            </Link>
            ).
          </>
        }
        variant="regular"
      />
      <Paragraph
        text={t('imAuthenticationSuccess.additionalInfo')}
        variant="regular"
      />
      <Paragraph
        text={t('imAuthenticationSuccess.additionalAccess')}
        variant="italic"
      />
    </>
  );

  return (
    <AuthSuccess
      BannerImg={AuthBannerImg}
      LogoCommon={AuthLogoCommon}
      SuccessContent={AuthSuccessContent}
    />
  );
};

export default IAMAuthSuccess;
